import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import './theme/fonts.css';
import './index.css';
import './syncfusion-license';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import store from './store/index';
import theme from './theme/theme';
import ThemeCssVariables from './theme/ThemeCssVariables';
import { NotifyProvider } from './Components/ui';

// Syncfusion license is registered in `./syncfusion-license` (side-effect import).

// Note: Axios interceptors are now handled in axios-config.js
// The centralized axios instance is used via getApiClient() in API service files

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <ThemeCssVariables />
      <NotifyProvider>
        <App />
      </NotifyProvider>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
